import { render, staticRenderFns } from "./ProfileCustomizePanel.vue?vue&type=template&id=3877f616&"
import script from "./ProfileCustomizePanel.vue?vue&type=script&lang=js&"
export * from "./ProfileCustomizePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports